import {AppRegistry} from 'react-native';
import '@fe-progressive/package-progressive/wallet-web-new/style.css';
import '@fe-progressive/package-progressive/recharge-web/style.css';
import '@fe-progressive/package-progressive/withdraw/style.css';
import '@fe-progressive/package-progressive/vip-web/style.css';
import '@fe-progressive/package-progressive/profile-web/style.css';
import '@fe-progressive/package-progressive/luckyspin-web/style.css';
import '@fe-progressive/package-progressive/records-web/style.css';
import '@fe-progressive/package-progressive/transaction-web/style.css';
import '@fe-progressive/package-progressive/progressive-toast/style.css';
import '@fe-progressive/package-progressive/progressive-loading/style.css';
import App from './App';
import {loadWebConfig} from './services/web-config.service';
import {webConfig} from './services/web-config.state';
import './index.scss';
import {initSentry} from './utils/sentry/instrument';

import './theme.css';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.dir = () => {};
  console.table = () => {};
  console.group = () => {};
}

initSentry(process.env.REACT_APP_SENTRY_DSN, process.env.REACT_APP_ENV);

const addRuntimeResourceHints = () => {
  if (!webConfig.gr8IframeUrl) {
    return;
  }

  try {
    const resourceOrigin = new URL(webConfig.gr8IframeUrl).origin;
    ['dns-prefetch', 'preconnect'].forEach(rel => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = resourceOrigin;
      if (rel === 'preconnect') {
        link.crossOrigin = '';
      }
      document.head.appendChild(link);
    });
  } catch (_) {}
};

// 配置请求先启动，但不阻塞首屏渲染；Web API 请求会等待同一个 Promise。
const webConfigPromise = loadWebConfig();

AppRegistry.registerComponent('App', () => App);
AppRegistry.runApplication('App', {
  rootTag: document.getElementById('root'),
});

webConfigPromise.then(addRuntimeResourceHints);
